module.exports = __webpack_public_path__ + "static/media/nat-geo.72ce820f.jpg";